import { cloneElement, type HTMLAttributes, type ReactElement, type ReactNode } from "react";

import { cn } from "@/lib/utils";

interface DrawerEmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: ReactElement<{ className?: string }>;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

const DrawerEmptyState = ({
  icon,
  title,
  description,
  action,
  className,
  ...props
}: DrawerEmptyStateProps) => (
  <div className={cn("flex items-center justify-center px-6 py-8", className)} {...props}>
    <div className="flex max-w-sm flex-col items-center text-center">
      {icon && (
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100">
          {cloneElement(icon, {
            className: cn(icon.props.className, "h-5 w-5 text-gray-500"),
          })}
        </div>
      )}
      <h3 className={cn("text-sm font-semibold text-gray-900", icon && "mt-3")}>{title}</h3>
      {description && <p className="mt-1.5 text-sm leading-5 text-gray-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  </div>
);

export default DrawerEmptyState;
